locationFullplayerQuery